import * as React                  from 'react';

import { Dialog                  } from 'src/components/common/dialog';
import { OneActionDialog         } from 'src/components/common/one-action-dialog';

import { RSODHelpDialogVariants,
         rsodhelpdialog_variants } from 'src/components/features/inspection/common/rsod-help-dialog/ui';



type Props = {
  opened: boolean;
  variant: RSODHelpDialogVariants;
  onAction: () => void;
}
export const RSODHelpDialog: React.FC<Props> = ({
  opened,
  variant,
  onAction,
}) => {
  const lookAndFeel = rsodhelpdialog_variants.get(variant)!;

  return (
    <Dialog variant = { lookAndFeel.dialogVariant } isOpened = { opened }>
      <OneActionDialog
        variant = { lookAndFeel.oneActionVarint }
        caption = 'Что такое "Прокат в состоянии поставки"?'
        message = 'Это означает, что металлопрокат находится в том же состоянии и качестве, в котором был отгружен Поставщиком. Без дополнительной обработки Потребителем. Т.е. не порезан, не в готовом изделии, без обработки поверхности и т.п.'
        actionLabel = 'Ok'
        onAction = { onAction }
      />
    </Dialog>
  );
};
